import { Outlet } from '@tanstack/react-router'

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

import { AdminHeader } from './header'
import { AdminSidebar } from './sidebar'

export function AdminLayout() {
  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset className="overflow-x-hidden">
        <AdminHeader />
        <div className="flex-1 overflow-hidden p-2">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
